import { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Fragment } from "react";
import "./CreateProductForm.css";
import { createProduct } from "../../../Redux/Customers/Product/Action";
import { useParams } from "react-router-dom";
import {
  findProductById,
  updateProduct,
} from "../../../Redux/Customers/Product/Action";
import { FileUploadWithPreview } from "file-upload-with-preview";
import ImageUploading from "react-images-uploading";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateProductForm = () => {
  const navigate = useNavigate();

  const { customersProduct } = useSelector((store) => store);

  const initialSizes = [
    { name: "S", quantity: "" },
    { name: "M", quantity: "" },
    { name: "L", quantity: "" },
    { name: "XL", quantity: "" },
    { name: "XXL", quantity: "" },
  ];

  const initialProductData = {
    imageUrl: "",
    images: [],
    brand: "",
    title: "",
    color: "",
    discountedPrice: "",
    price: "",
    discountPercent: "",
    sizes: initialSizes,
    quantity: "",
    topLavelCategory: {
      name: "men",
      title: "Men",
    },
    secondLavelCategory: {
      name: "",
      title: "",
    },
    thirdLavelCategory: {
      name: "",
      title: "",
    },
    fourthLavelCategory: {
      name: "",
      title: "",
    },
    description: "",
    isSizesAvailable: true,
  };
  const [productData, setProductData] = useState(initialProductData);

  const { productId } = useParams();

  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");

  const categories = [
    {
      title: "Clothing",
      value: "clothing",
      level: 2,
      parentCat: "men",
    },
    {
      title: "Wedding Collection",
      value: "wedding_collection",
      level: 2,
      parentCat: "men",
    },
    {
      title: "Accessories",
      value: "accessories",
      level: 2,
      parentCat: "men",
    },
    {
      title: "Shirts",
      value: "shirts",
      level: 3,
      parentCat: "clothing",
      wearType: "top",
    },
    {
      title: "T-Shirts",
      value: "t_shirts",
      level: 3,
      parentCat: "clothing",
      wearType: "top",
    },
    {
      title: "Trousers",
      value: "trousers",
      level: 3,
      parentCat: "clothing",
      wearType: "bottom",
    },
    {
      title: "Jeans",
      value: "jeans",
      level: 3,
      parentCat: "clothing",
      wearType: "bottom",
    },
    {
      title: "Shervani",
      value: "shervani",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Achkan",
      value: "achkan",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Ethenic",
      value: "ethenic",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Kurta Pajama",
      value: "kurta_pajama",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Safa",
      value: "safa",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Fabric",
      value: "fabric",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Koti",
      value: "koti",
      level: 3,
      parentCat: "wedding_collection",
    },
    {
      title: "Mod",
      value: "mod",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Kalangi",
      value: "kalangi",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Surface",
      value: "surface",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Mala",
      value: "mala",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Kantha Surface",
      value: "kanta_surface",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Shervani Belt",
      value: "shervani_belt",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Chandi Katari",
      value: "chandi_katari",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Peetal Katari",
      value: "peetal_katari",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Chandi Talwar",
      value: "chandi_talwar",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Jhalari",
      value: "jhalari",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Shervani Juti",
      value: "shervani_juti",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Katar Belt",
      value: "katar_belt",
      level: 3,
      parentCat: "accessories",
    },
    {
      title: "Plain",
      value: "plain_shirts",
      level: 4,
      parentCat: "shirts",
    },
    {
      title: "Sanganeri",
      value: "sanganeri_shirts",
      level: 4,
      parentCat: "shirts",
    },
    {
      title: "Checks",
      value: "checks_shirts",
      level: 4,
      parentCat: "shirts",
    },
    {
      title: "Double Pocket",
      value: "double_pocket_shirts",
      level: 4,
      parentCat: "shirts",
    },
    {
      title: "Hunting",
      value: "hunting_shirts",
      level: 4,
      parentCat: "shirts",
    },
    {
      title: "Polo",
      value: "polo_t_shirts",
      level: 4,
      parentCat: "t_shirts",
    },
    {
      title: "Chino",
      value: "chino_trousers",
      level: 4,
      parentCat: "trousers",
    },
    {
      title: "Cotton",
      value: "cotton_trousers",
      level: 4,
      parentCat: "trousers",
    },
    {
      title: "Formal",
      value: "formal_trousers",
      level: 4,
      parentCat: "trousers",
    },
    {
      title: "Cargo",
      value: "cargo_trousers",
      level: 4,
      parentCat: "trousers",
    },
    {
      title: "Joggers",
      value: "joggers_trousers",
      level: 4,
      parentCat: "trousers",
    },
    {
      title: "Ankle Length",
      value: "ankle_length_jeans",
      level: 4,
      parentCat: "jeans",
    },
    {
      title: "Straigth Fit",
      value: "straight_fit_jeans",
      level: 4,
      parentCat: "jeans",
    },
    {
      title: "Bell Bottom",
      value: "bell_bottom_jeans",
      level: 4,
      parentCat: "jeans",
    },
    {
      title: "Plain Shervani",
      value: "plain_shervani",
      level: 4,
      parentCat: "shervani",
    },
    {
      title: "Work Shervani",
      value: "work_shervani",
      level: 4,
      parentCat: "shervani",
    },
    {
      title: "Hand Work Shervani",
      value: "hand_work_shervani",
      level: 4,
      parentCat: "shervani",
    },
    {
      title: "Hand Work Angrakha",
      value: "hand_work_angrakha_shervani",
      level: 4,
      parentCat: "shervani",
    },
    {
      title: "Jodhpuri Suit",
      value: "jodhpuri_suit_ethenic",
      level: 4,
      parentCat: "ethenic",
    },
    {
      title: "3 Piece Suit",
      value: "3_piece_suit_ethenic",
      level: 4,
      parentCat: "ethenic",
    },
    {
      title: "2 Piece Suit",
      value: "2_piece_suit_ethenic",
      level: 4,
      parentCat: "ethenic",
    },
    {
      title: "Plain",
      value: "plain_koti",
      level: 4,
      parentCat: "koti",
    },
    {
      title: "Hunting",
      value: "hunting_koti",
      level: 4,
      parentCat: "koti",
    },
    {
      title: "Printed",
      value: "printed_koti",
      level: 4,
      parentCat: "koti",
    },
    {
      title: "Velvet",
      value: "velvet_koti",
      level: 4,
      parentCat: "koti",
    },
    {
      title: "Pure",
      value: "pure_safa",
      level: 4,
      parentCat: "safa",
    },
    {
      title: "Cotton",
      value: "cotton_safa",
      level: 4,
      parentCat: "safa",
    },
    {
      title: "Shirting",
      value: "shirting_fabric",
      level: 4,
      parentCat: "fabric",
    },
    {
      title: "Shervani",
      value: "shervani_fabric",
      level: 4,
      parentCat: "fabric",
    },
    {
      title: "Suit",
      value: "suit_fabric",
      level: 4,
      parentCat: "fabric",
    },
    {
      title: "Kurta Pajama",
      value: "kurta_pajama_fabric",
      level: 4,
      parentCat: "fabric",
    },
  ];

  const handleChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    if (
      name == "topLavelCategory" ||
      name == "secondLavelCategory" ||
      name == "fourthLavelCategory"
    ) {
      value = {
        name: value,
        title: categories.find((cat) => cat.value == value).title,
      };
    }
    if (name == "thirdLavelCategory") {
      value = {
        name: value,
        title: categories.find((cat) => cat.value == value).title,
        wearType: categories.find((cat) => cat.value == value)?.wearType,
      };
    }
    if (
      name == "discountedPrice" ||
      name == "price" ||
      name == "discountPercent" ||
      name == "quantity"
    ) {
      value = value ? Number(value) : "";
      if (name == "discountPercent") {
        value = value > 100 ? 100 : value < 0 ? 0 : value;
      }
    }
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSizeChange = (e, index) => {
    let { name, value } = e.target;
    name === "size_quantity" ? (name = "quantity") : (name = e.target.name);

    const sizes = [...productData.sizes];
    if (name == "quantity") {
      value = value ? Number(value) : "";
    }
    sizes[index][name] = value;
    setProductData((prevState) => ({
      ...prevState,
      sizes: sizes,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (productData.isSizesAvailable) {
      let totalSizesQuantity = productData.sizes.reduce(
        (accum, item) => accum + item.quantity,
        0
      );
      if (productData.quantity != totalSizesQuantity) {
        toast.error("Total of all sizes and given quantity is not equal!");
        return;
      }
    }
    if (productId) {
      const productDataBody = {
        ...productData,
        productId: productId,
      };
      dispatch(updateProduct(productDataBody));
    } else {
      dispatch(createProduct({ data: productData, jwt }));
    }
    setProductData({
      ...initialProductData,
      sizes: initialSizes,
      // images: productData.images,
    });
  };

  useEffect(() => {
    if (productId) {
      dispatch(findProductById({ productId }));
    }
  }, [productId]);

  useEffect(() => {
    setProductData(initialProductData);
  }, []);

  useEffect(() => {
    setProductData((prevState) => ({
      ...prevState,
      discountedPrice:
        Number(prevState.price) -
        (Number(prevState.price) * Number(prevState.discountPercent)) / 100,
    }));
  }, [productData]);

  useEffect(() => {
    if (productId && customersProduct.product) {
      for (let key in productData) {
        setProductData((prev) => ({
          ...prev,
          [key]: customersProduct.product[key],
        }));
      }
    }
  }, [customersProduct.product]);

  const uploadImages = (e) => {
    const files = e.target.files;
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }
    axios
      .post("https://aashapurasafahouse-server.onrender.com/upload", formData)
      .then((res) => {
        const images = res.data.files.map((file) => file.location);

        setProductData((prevState) => ({
          ...prevState,
          images: images,
        }));
      })
      .catch((er) => {
        return er;
      });
  };

  return (
    <Fragment>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        // transition="Flip"
      />
      <Typography
        variant="h4"
        sx={{ textAlign: "center" }}
        className="py-5 text-center "
      >
        {productId ? "Edit Product" : "Add New Product"}
      </Typography>

      {/* <input
          type="file"
          onChange={(e) => setFiles(e.target.files)}
          multiple
          name="files"
        />
        <button type="button" onClick={upload}>
          Upload
        </button> */}

      <form
        onSubmit={handleSubmit}
        className="createProductContainer min-h-screen"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label for="images" class="drop-container" id="dropcontainer">
              <span class="drop-title">Click or Drop files here</span>
              <input
                type="file"
                id="images"
                accept="image/*"
                required={productId ? false : true}
                onChange={(e) => uploadImages(e)}
                multiple
                name="files"
                className="hidden"
              />
              <div className="flex flex-wrap">
                {productData.images.map((imgUrl) => (
                  <img
                    src={imgUrl}
                    alt={imgUrl}
                    className="object-cover object-center flex mr-3"
                    width={70}
                    height={70}
                  />
                ))}
              </div>
            </label>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Brand"
              name="brand"
              required
              value={productData.brand}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              required
              value={productData.title}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Color"
              name="color"
              required
              value={productData.color}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Quantity"
              name="quantity"
              required
              value={productData.quantity}
              onChange={handleChange}
              type="number"
              onWheel={(e) => e.target.blur()}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Price"
              name="price"
              required
              value={productData.price}
              onChange={handleChange}
              type="number"
              onWheel={(e) => e.target.blur()}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discount Percentage"
              name="discountPercent"
              required
              value={productData.discountPercent}
              onChange={handleChange}
              type="number"
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                  step: "1",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discounted Price"
              name="discountedPrice"
              value={productData.discountedPrice}
              onChange={handleChange}
              type="number"
              disabled
            />
          </Grid>

          <Grid item xs={12} md={6} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Top Level Category</InputLabel>
              <Select
                name="topLavelCategory"
                value={productData?.topLavelCategory?.name}
                onChange={handleChange}
                label="Top Level Category"
                required
              >
                <MenuItem value="men">Men</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Second Level Category</InputLabel>

              <Select
                name="secondLavelCategory"
                value={productData?.secondLavelCategory?.name}
                onChange={handleChange}
                label="Second Level Category"
                required
              >
                {categories.map((cat) => {
                  return (
                    cat.level == 2 && (
                      <MenuItem value={cat.value}>{cat.title}</MenuItem>
                    )
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Third Level Category</InputLabel>
              <Select
                name="thirdLavelCategory"
                value={productData?.thirdLavelCategory?.name}
                onChange={handleChange}
                label="Third Level Category"
                required
              >
                {productData.secondLavelCategory?.name &&
                  categories
                    .filter(
                      (cat) =>
                        cat.parentCat ==
                          productData.secondLavelCategory?.name &&
                        cat.level == 3
                    )
                    .map((cat) => {
                      return <MenuItem value={cat.value}>{cat.title}</MenuItem>;
                    })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Fourth Level Category</InputLabel>
              <Select
                name="fourthLavelCategory"
                value={productData.fourthLavelCategory?.name}
                onChange={handleChange}
                label="Fourth Level Category"
              >
                {productData.thirdLavelCategory?.name &&
                  categories
                    .filter(
                      (cat) =>
                        cat.parentCat == productData.thirdLavelCategory?.name &&
                        cat.level == 4
                    )
                    .map((cat) => {
                      return <MenuItem value={cat.value}>{cat.title}</MenuItem>;
                    })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Description"
              multiline
              name="description"
              rows={3}
              onChange={handleChange}
              value={productData.description}
              required
            />
          </Grid>
          <Grid container item spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={productData.isSizesAvailable}
                      label="Sizes Avaialble?"
                      onChange={(e) =>
                        setProductData((prevState) => ({
                          ...prevState,
                          isSizesAvailable: e.target.checked,
                        }))
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Sizes Available?"
                />
              </FormGroup>
              {/* <Checkbox
                checked={productData.isSizesAvailable}
                label="Sizes Avaialble?"
                onChange={(e) =>
                  setProductData((prevState) => ({
                    ...prevState,
                    isSizesAvailable: e.target.checked,
                  }))
                }
                inputProps={{ "aria-label": "controlled" }}
              /> */}
            </Grid>
          </Grid>
          {productData.sizes.map((size, index) => (
            <Grid
              container
              item
              spacing={3}
              sx={{
                display: productData.isSizesAvailable ? "visible" : "none",
              }}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Size Name"
                  name="name"
                  value={size.name}
                  onChange={(event) => handleSizeChange(event, index)}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Quantity"
                  name="size_quantity"
                  type="number"
                  value={size.quantity}
                  onChange={(event) => handleSizeChange(event, index)}
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
            </Grid>
          ))}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "20px 0",
              width: "100%",
            }}
          >
            <Button variant="contained" type="submit">
              Submit
            </Button>
          </Box>
        </Grid>
      </form>
    </Fragment>
  );
};

export default CreateProductForm;
